/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { getSfredBuyedByUser } from "../services/NftServices";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { FaCircleChevronLeft, FaCopy } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import Loader from "../components/loader/loader";
import NoData from "../components/NoDataComp/NoData";
import Pagination from "@mui/material/Pagination";
import SuperFredCard from "../components/SuperFred/SuperFredCard";
import UserSuperFredCard from "../components/SuperFred/UserSuperFredCard";
import { useActiveAccount } from "thirdweb/react";
const debounceTime = 300;
let distinctUntilChanged = null;

const ViewAllBuySfreds = () => {
  const activeAccount=useActiveAccount();
  const navigate = useNavigate();
  const [sfredData, setSfredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState("");
  const [filter, setFilter] = useState("");
  const fetchSfreds = async (
    pageNumber = page,
    pageSize = 12,
    search = filter
  ) => {
    try {
      setLoading(true);
      const response = await getSfredBuyedByUser(activeAccount?.address);
      if (response.status === 200) {
        setSfredData(response?.data);
        // setTotalData(response?.data?.totalItems);
        setLoading(false);
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching nft data:", error);
    }
  };

  const handleSearch = (val) => {
    const value = val.trim();
    setFilter(value);
    if (distinctUntilChanged) {
      clearTimeout(distinctUntilChanged);
      distinctUntilChanged = null;
    }
    distinctUntilChanged = setTimeout(() => {
      setFilter(value);
      fetchSfreds(1, 8, value);
      distinctUntilChanged = null;
    }, debounceTime);
  };

  useEffect(() => {
    fetchSfreds();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          className="back-btn fw-500 text-black py-4"
          onClick={() => navigate(-1)}
        >
          <i className="pe-2 align-middle">
            <FaCircleChevronLeft />
          </i>
          Back
        </Link>
        <div>
          <input
            type="search"
            placeholder="Search SFRED"
            style={{
              borderRadius: "12px",
              border: "none",
              padding: "5px 20px",
              background: "#d3d3d3a1",
            }}
            value={filter}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="dashboard-centerd">
          {sfredData?.length > 0 ? (
            <div className="row g-0">
              <div className="row mb-4">
                {sfredData?.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="col-xxl-3 col-xl-3 col-md-6 col-12 mb-4"
                    >
                      <UserSuperFredCard
                        data={item}
                        fetchData={fetchSfreds}
                        setLoading={setLoading}
                      />
                    </div>
                  );
                })}
              </div>
              {totalData > 12 && (
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    // minWidth: "200%",
                  }}
                >
                  <Pagination
                    color="primary"
                    count={Math.ceil(totalData / 12)}
                    page={page}
                    onChange={(e, v) => setPage(v)}
                    // activePage={page}
                  />
                </div>
              )}
            </div>
          ) : (
            <NoData />
          )}
        </div>
      )}
    </div>
  );
};

export default ViewAllBuySfreds;
